import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.title',
        defaultMessage: 'Request Top Up'
    },
    turnoverQuestion: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.turnover_question',
        defaultMessage:
            'How much did your business turnover in the last 12 months?'
    },
    turnoverQuestionInfo: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.turnover_question_info',
        defaultMessage:
            'Normally we’ll be able to approve you for a maximum of 10% of your annual turnover'
    },
    turnoverError: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.turnover_Error',
        defaultMessage: 'Turnover is Required'
    },
    creditQuestion: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.credit_question',
        defaultMessage: 'How much more would you like to borrow?'
    },
    creditError: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.credit_Error',
        defaultMessage: 'Please enter how much is required'
    },
    minCreditError: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.min_credit_Error',
        defaultMessage: 'Please enter an amount greater than {minAmount}'
    },
    maxCreditError: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.max_credit_Error',
        defaultMessage: 'The maximum you can request is {maxAmount}'
    },
    reasonQuestion: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.reason_question',
        defaultMessage:
            'What is your main reason for requesting a Revenue Based Loan?'
    },
    reasonPlaceholder: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.reason_placeholder',
        defaultMessage: 'Choose a Reason'
    },
    reasonError: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.reason_error',
        defaultMessage: 'Reason is Required'
    },
    detailedReason: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.detailed_reason',
        defaultMessage: 'Detailed Reason'
    },
    detailedReasonError: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.detailed_reason_error',
        defaultMessage: 'Detailed Reason is Required'
    },
    nextButton: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.next_button',
        defaultMessage: 'Continue'
    },
    newCreditLimit: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.newCreditLimit',
        defaultMessage: 'Your new credit limit would be: '
    },
    currentCreditLimit: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.currentCreditLimit',
        defaultMessage: '(Current credit limit {limit})'
    },
    unchangedCreditLimit: {
        id: '_.rbl_dashboard.outstanding.rblTopUpForm.unchangedCreditLimit',
        defaultMessage: 'Your credit limit will remain: '
    }
});
